class Timeline {
	constructor(el) {
		this.el = el;
		this.viewport = el.querySelector('.wp-block-embark-timeline__viewport');
		this.track = el.querySelector('.wp-block-embark-timeline__track');
		this.items = [...this.track.children];
		this.total = this.items.length;
		this.page = 0;
		this.prevBtn = el.querySelector('.wp-block-embark-timeline__arrow--prev');
		this.nextBtn = el.querySelector('.wp-block-embark-timeline__arrow--next');

		this.dragStartX = 0;
		this.dragDelta = 0;
		this.isDragging = false;

		this.prevBtn.addEventListener('click', () => this.navigate(-1));
		this.nextBtn.addEventListener('click', () => this.navigate(1));
		window.addEventListener('resize', () => this.render());

		this.viewport.addEventListener('mousedown', (e) => this.onDragStart(e));
		window.addEventListener('mousemove', (e) => this.onDragMove(e));
		window.addEventListener('mouseup', (e) => this.onDragEnd(e));
		this.viewport.addEventListener('dragstart', (e) => e.preventDefault());

		this.viewport.addEventListener('touchstart', (e) => this.onDragStart(e), { passive: true });
		window.addEventListener('touchmove', (e) => this.onDragMove(e), { passive: true });
		window.addEventListener('touchend', (e) => this.onDragEnd(e));

		this.render();
	}

	perPage() {
		return window.innerWidth >= 1024 ? 5 : 3;
	}

	navigate(dir) {
		const totalPages = Math.ceil(this.total / this.perPage());
		this.page = Math.max(0, Math.min(this.page + dir, totalPages - 1));
		this.render();
	}

	onDragStart(e) {
		this.isDragging = true;
		this.dragDelta = 0;
		this.dragStartX = e.touches ? e.touches[0].clientX : e.clientX;
		this.track.style.transition = 'none';
		this.viewport.style.cursor = 'grabbing';
	}

	onDragMove(e) {
		if (!this.isDragging) return;
		const x = e.touches ? e.touches[0].clientX : e.clientX;
		this.dragDelta = x - this.dragStartX;
		const baseOffset = this.page * this.viewport.offsetWidth;
		this.track.style.transform = `translateX(${-baseOffset + this.dragDelta}px)`;
	}

	onDragEnd(e) {
		if (!this.isDragging) return;
		this.isDragging = false;
		this.track.style.transition = '';
		this.viewport.style.cursor = '';

		const threshold = this.viewport.offsetWidth * 0.2;
		if (this.dragDelta < -threshold) {
			this.navigate(1);
		} else if (this.dragDelta > threshold) {
			this.navigate(-1);
		} else {
			this.render();
		}
	}

	render() {
		this.track.style.transform = `translateX(-${this.page * this.viewport.offsetWidth}px)`;

		const totalPages = Math.ceil(this.total / this.perPage());
		this.prevBtn.disabled = this.page === 0;
		this.nextBtn.disabled = this.page >= totalPages - 1;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-embark-timeline').forEach((el) => new Timeline(el));
});
